<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent scrollable max-width="500">
            <ValidationObserver ref="obs">
                <v-card>
                    <v-progress-linear
                        v-if="loading"
                        indeterminate
                        color="primary"
                        rounded
                        height="6"
                    ></v-progress-linear>

                    <v-card-title class="pa-0 shadow-1">
                        <v-img
                            :src="
                                require('@/assets/illustrations/bg_modal_card.svg')
                            "
                            cover
                            position="left bottom"
                            class="align-center"
                            height="65px"
                        >
                            <v-card-title
                                class="font-weight-medium primary--text"
                            >
                                {{ titleMode }} Respuesta
                            </v-card-title>
                        </v-img>
                    </v-card-title>

                    <vuescroll
                        :ops="{    bar: { background: '#bacfcec0', keepShow: true }  }"
                    >
                        <v-card-text style="max-height: 350px">
                            <v-form>
                                <v-row dense>
                                    <v-col cols="12">
                                        <ValidationProvider
                                            name="Titulo"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <v-text-field
                                                required
                                                filled
                                                rounded
                                                class="rounded-small"
                                                dense
                                                label="Respuesta"
                                                name="name"
                                                prepend-inner-icon="mdi-label-variant"
                                                type="text"
                                                color="blue-grey"
                                                v-model="answerData.name"
                                                :error-messages="errors"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12">
                                        <ValidationProvider
                                            name="Titulo"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <v-text-field
                                                required
                                                filled
                                                rounded
                                                class="rounded-small"
                                                dense
                                                label="Valor"
                                                name="value"
                                                prepend-inner-icon="mdi-label-variant"
                                                type="text"
                                                color="blue-grey"
                                                v-model="answerData.value"
                                                :error-messages="errors"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </vuescroll>
                    <v-divider></v-divider>

                    <v-card-actions class="mx-2">
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                text
                                rounded
                                class="mr-1"
                                :color="hover ? 'error' : 'grey'"
                                @click="closeDialog"
                                >Cancelar</v-btn
                            >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                rounded
                                :loading="loading"
                                :disabled="loading"
                                color="success"
                                :class="hover ? 'shadow-2' : 'shadow-4'"
                                class="px-8"
                                @click.stop="submitForm()"
                                >{{ submitButtonMode }}</v-btn
                            >
                        </v-hover>
                    </v-card-actions>
                </v-card>
            </ValidationObserver>
        </v-dialog>
    </v-row>
</template>

<script>
import vuescroll from "vuescroll";

const initialData = {
    answerData: {
        name: "",
        value: ""
    }
};
export default {
    props: {
        formDialog: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: "register"
        },
        dataToForm: {
            type: Object
        },
        idQuestion: {
            type: Number
        }
    },
    components: { vuescroll },
    data() {
        return {
            loading: false,
            answerData: { ...initialData.answerData },
            errorData: "",
            activeAlert: false,
            colorAlert: ""
        };
    },
    beforeUpdate() {
        if (this.mode !== "register") this.answerData = { ...this.dataToForm };
    },
    computed: {
        dialog() {
            return this.formDialog;
        },

        titleMode() {
            return this.mode === "register" ? "Nueva" : "Editar";
        },
        submitButtonMode() {
            return this.mode === "register" ? "añadir" : "actualizar";
        }
    },

    methods: {
        closeDialog() {
            this.categoryData = { ...initialData.answerData };
            this.$emit("answerFormDialog:close");
        },
        async submitForm() {
            if (this.mode === "register") {
                const response = await this.$store.dispatch(
                    "answers/REGISTER_ANSWER",
                    {...this.answerData, question_id: Number(this.idQuestion)}
                );
                if (response === 422){
                this.$snotify.error("La suma de la respuesta es mayor a 100%", "Error");
                return
                }else
                this.$snotify.success("Respuesta creada con éxito.", "¡Hecho!");
            } else {
                const response = await this.$store.dispatch(
                    "answers/EDIT_ANSWER",
                    this.answerData
                );
                if (response === 422 || this.answerData.value > 100){
                this.$snotify.error("La suma de la respuesta es mayor a 100%", "Error");
                return
                }else
                this.$snotify.success(
                    "Respuesta actualizada con éxito.",
                    "¡Hecho!"
                );
            }
            this.closeDialog();
        }
    }
};
</script>
